import http from './httpService';

const apiEndPoint = '/trade-types';

function tradeTypeUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getTradeTypes() {
  return http.get(apiEndPoint);
}

export function getTradeType(tradeTypeId) {
  return http.get(tradeTypeUrl(tradeTypeId));
}

export function saveTradeType(tradeType) {
  if (tradeType._id) {
    const body = { ...tradeType };
    delete body._id;
    return http.put(tradeTypeUrl(tradeType._id), body);
  }

  return http.post(apiEndPoint, tradeType);
}

export function deleteTradeType(tradeTypeId) {
  return http.delete(tradeTypeUrl(tradeTypeId));
}
